/**
 * Conteúdo das regras ("Como Jogar"), em português.
 *
 * Este texto foi derivado diretamente do código do jogo (game-server,
 * server-cards e card-inventory-server) e verificado contra ele. Ao mudar uma
 * regra no jogo, atualize também este arquivo.
 *
 * Os dados dinâmicos (cartas e territórios) vêm do endpoint de catálogo; só as
 * regras gerais ficam aqui, pois descrevem o sistema e não itens individuais.
 */

export interface RulesSection {
  /** Âncora para o sumário (kebab-case). */
  id: string;
  title: string;
  /** Markdown (##/###, listas, **negrito**, `código`). */
  body: string;
}

export interface GlossaryEntry {
  term: string;
  definition: string;
}

export interface RulesDoc {
  intro: string;
  sections: RulesSection[];
  glossary: GlossaryEntry[];
}

import rulesData from './rules.json';

// O conteúdo vive em rules.json (texto puro, sem precisar escapar markdown).
// Foi extraído do código do jogo e verificado contra ele (0 divergências).
export const RULES: RulesDoc = rulesData as RulesDoc;
